module.exports = __webpack_public_path__ + "static/img/list_bg.e7c9027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/list_bg.png
// module id = 38lt
// module chunks = 44